import * as Output from '../../Text';

export const street = v => (!v || /^(?! )[^/()@#$%^&*!=+><~:,;{}[\]]*$/.test(v)
  ? undefined
  : Output.resolve(
    'generic.errors.M002_invalidCharacters',
  ));
